import { FULL_NAME_LIMIT } from '@oefy/core';
import { z } from 'zod';
import { avatarColorSchema, avatarSchema, childProfileSchema } from './auth';
import { schoolGroupSchema } from './common';

export const MAX_CHILDREN = 6;

export const childInputSchema = z.object({
  firstName: z.string().trim().min(1).max(40),
  schoolGroup: schoolGroupSchema,
  avatar: avatarSchema.optional(),
  avatarColor: avatarColorSchema.optional(),
});

export const accountInputSchema = z.object({
  name: z.string().trim().max(FULL_NAME_LIMIT),
});

export const accountSchema = z.object({
  name: z.string().nullable(),
  photoUrl: z.string().nullable(),
});

export const photoParamsSchema = z.object({ photoId: z.uuid() });

export const childPreferencesSchema = z.object({
  textScale: z.int().min(-1).max(2),
});

export const familyChildSchema = childProfileSchema.extend({
  groups: z.array(schoolGroupSchema),
  groupLocked: z.boolean(),
  groupCheckDue: z.boolean(),
});

export const familyPlacesSchema = z.object({
  total: z.int().min(0),
  free: z.int().min(0),
  grant: z.boolean(),
});

export const familySchema = z.object({
  children: z.array(familyChildSchema),
  hasAccess: z.boolean(),
  maxChildren: z.int(),
  places: familyPlacesSchema,
  canAddChild: z.boolean(),
});

export const schoolYearAnswerSchema = z.object({
  movedUp: z.boolean(),
});

export type ChildInput = z.infer<typeof childInputSchema>;
export type AccountInput = z.infer<typeof accountInputSchema>;
export type Account = z.infer<typeof accountSchema>;
export type ChildPreferences = z.infer<typeof childPreferencesSchema>;
export type FamilyChild = z.infer<typeof familyChildSchema>;
export type FamilyPlacesView = z.infer<typeof familyPlacesSchema>;
export type Family = z.infer<typeof familySchema>;
export type SchoolYearAnswer = z.infer<typeof schoolYearAnswerSchema>;
